import styled from 'styled-components'

interface TableProps {
  condensed?: boolean
}

export default styled.table<TableProps>`
  height: min-content;
  border-collapse: collapse;
  flex: 1;
  min-width: 400px;
  width: 100%;

  tr td:nth-child(1) {
    font: var(--600-13);
  }

  th,
  td {
    padding: ${({ condensed }) => (condensed ? 4 : 14)}px;
    text-align: left;
  }

  th {
    word-break: break-word;
    min-width: 136px;
    border-bottom: 1px solid var(--green);
    font: var(--600-13);
  }

  td {
    word-break: break-word;
    margin-top: 10px;
    border-bottom: 1px solid var(--light-gray);
    font: var(--400-13);
  }

  .hiddenRow {
    display: none;
  }

  .expandedRow {
    background: var(--very-light-blue);
  }

  tr.firstExpandedRow > td {
    border-bottom: none;
  }
`
